import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import DealershipForm from '../../components/forms/DealershipForm'

const CreateDealership = () => {
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Create Dealership</Typography>
      </Box>
      <DealershipForm />
    </Container>
  )
}

export default CreateDealership
